import React from 'react';
import '../../../style/Dashboard.css';
// import DashNav from './DashNav';
import CspDashBoardScreen from './CspDashBoardScreen';
export default function CspDashhboard() {
  return (
   <>
  


 <CspDashBoardScreen/>
   
   </>
  )
}
